import { render, staticRenderFns } from "./TransacaoForm.vue?vue&type=template&id=86c3ff40"
import script from "./TransacaoForm.vue?vue&type=script&lang=js"
export * from "./TransacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports